var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"close-popover",rawName:"v-close-popover",value:(true),expression:"true"}],staticClass:"v-popover-close-btn"},[_c('v-icon',{attrs:{"size":"0.5em"}},[_vm._v("close")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }